import * as HLF from "html-living-framework";
import {Application} from "../Application";

export class BgmMixer {

    private static _internalVolume = 1;
    private static _externalVolume = 1;

    public static setInternalVolume(value: number) {
        this._internalVolume = value;
        Application.instance.audio.setCategoryVolume(HLF.AudioCategory.BGM, this._internalVolume * this._externalVolume);
    }

    public static setExternalVolume(value: number) {
        this._externalVolume = value;
        Application.instance.audio.setCategoryVolume(HLF.AudioCategory.BGM, this._internalVolume * this._externalVolume);
    }
}
